/* SQUISHD Theme JS */

const cursor = document.getElementById('cursor');
if (cursor && window.matchMedia('(hover:hover)').matches) {
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
  });
  function bindCursor() {
    document.querySelectorAll('a,button,.product-card,.showcase-card,.bundle-card,.feat-card,.faq-q').forEach(el => {
      if (!el._c) { el._c = true; el.addEventListener('mouseenter', () => cursor.classList.add('big')); el.addEventListener('mouseleave', () => cursor.classList.remove('big')); }
    });
  }
  bindCursor();
  document.addEventListener('click', bindCursor);
}

window.addEventListener('scroll', () => {
  const h = document.getElementById('siteHeader');
  if (h) h.classList.toggle('scrolled', window.scrollY > 40);
}, { passive: true });

function openMenu() {
  document.getElementById('mobileMenu')?.classList.add('open');
  document.getElementById('mmOverlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  document.getElementById('mobileMenu')?.classList.remove('open');
  document.getElementById('mmOverlay')?.classList.remove('open');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

function showNotif(msg) {
  const t = document.getElementById('notif');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._timer);
  t._timer = setTimeout(() => t.classList.remove('show'), 2800);
}

function fmoney(cents) { return '$' + (cents / 100).toFixed(2); }

async function updateCartCount() {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-badge').forEach(el => el.textContent = cart.item_count);
    return cart;
  } catch(e) { return null; }
}

function renderTotals(cart) {
  const total = document.getElementById('cartTotal');
  const was   = document.getElementById('cartTotalWas');
  const saved = document.getElementById('cartSaved');

  const before = (typeof cart.original_total_price === 'number')
    ? cart.original_total_price : cart.total_price;
  const after  = cart.total_price;
  const off    = before - after;

  if (total) total.textContent = fmoney(after);

  if (off > 0) {
    if (was) { was.textContent = fmoney(before); was.style.display = ''; }
    if (saved) {
      const pct = Math.round((off / before) * 100);
      saved.textContent = 'You saved ' + fmoney(off) + ' (' + pct + '% off)';
      saved.style.display = '';
    }
  } else {
    if (was) was.style.display = 'none';
    if (saved) saved.style.display = 'none';
  }
}

async function renderCart() {
  const body = document.getElementById('cartBody');
  const foot = document.getElementById('cartFoot');
  if (!body) return;
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn-p" onclick="closeCart()">Shop Now</a></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map(item => {
      const img = item.image
        ? `<img src="${item.image}" alt="" loading="lazy" style="width:76px;height:76px;object-fit:cover;border-radius:12px;border:2px solid #1A0A2E">`
        : '';
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="ci-var">${item.variant_title}</div>`
        : '';
      const linePrice = (item.original_line_price > item.final_line_price)
        ? `<span style="text-decoration:line-through;opacity:.4;font-size:.8rem;margin-right:5px">${fmoney(item.original_price)}</span>${fmoney(item.final_price)}`
        : fmoney(item.final_price);
      return `<div class="cart-item">
        <div class="ci-img">${img}</div>
        <div class="ci-info">
          <div class="ci-name">${item.product_title}</div>
          ${variant}
          <div class="ci-price">${linePrice}</div>
          <div class="ci-qty-row">
            <button data-key="${item.key}" data-qty="${item.quantity - 1}" onclick="changeQty(this)">−</button>
            <span>${item.quantity}</span>
            <button data-key="${item.key}" data-qty="${item.quantity + 1}" onclick="changeQty(this)">+</button>
            <button data-key="${item.key}" data-qty="0" onclick="changeQty(this)" class="ci-rm">Remove</button>
          </div>
        </div>
      </div>`;
    }).join('');
    renderTotals(cart);
    if (window.sqdTierBarRefresh) window.sqdTierBarRefresh();
  } catch(e) {
    body.innerHTML = '<p style="padding:20px;text-align:center;opacity:.5">Could not load cart.</p>';
  }
}

async function changeQty(btn) {
  const key = btn.getAttribute('data-key');
  const qty = parseInt(btn.getAttribute('data-qty'));
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  await updateCartCount();
  await renderCart();
}

function openCart() {
  document.getElementById('cartDrawer')?.classList.add('open');
  document.getElementById('cartOverlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}
function closeCart() {
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

function handleAddToCart(e, btn) {
  e.preventDefault();
  e.stopPropagation();
  const variantId = parseInt(btn.getAttribute('data-variant-id'));
  const title     = btn.getAttribute('data-product-title') || 'Product';
  if (!variantId) return;
  const orig = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled    = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent   = 'Added!';
    btn.style.background = '#7EFF5A';
    btn.style.color      = '#1A0A2E';
    showNotif(title + ' added to cart!');
    updateCartCount();
    openCart();
    setTimeout(() => {
      btn.textContent      = orig;
      btn.style.background = '';
      btn.style.color      = '';
      btn.disabled         = false;
    }, 2000);
  })
  .catch(() => {
    btn.textContent = orig;
    btn.disabled    = false;
    showNotif('Could not add to cart. Please try again.');
  });
}

function toggleFaq(btn) {
  const answer = btn.nextElementSibling;
  const isOpen = btn.classList.contains('open');
  document.querySelectorAll('.faq-q').forEach(q => {
    q.classList.remove('open');
    if (q.nextElementSibling) q.nextElementSibling.classList.remove('open');
  });
  if (!isOpen) { btn.classList.add('open'); answer.classList.add('open'); }
}

const revealObserver = new IntersectionObserver(entries => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => entry.target.classList.add('visible'), i * 80);
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

const fomoItems = [
  { av: '👩', name: 'Sarah from Sydney',    msg: ' just ordered the Gummy Bear' },
  { av: '👦', name: 'Liam from Melbourne',  msg: ' just ordered the Gumdrop Blue' },
  { av: '👩', name: 'Ava from Brisbane',    msg: ' just ordered the Nice Cube' },
  { av: '👨', name: 'James from Perth',     msg: ' just ordered 3 Gumdrop bundles' }
];
let fomoIdx = 0;
function showFomo(item) {
  const wrap = document.getElementById('fomoWrap');
  if (!wrap) return;
  document.getElementById('fomoAv').textContent   = item.av;
  document.getElementById('fomoName').textContent = item.name;
  document.getElementById('fomoMsg').textContent  = item.msg;
  wrap.classList.add('show');
  setTimeout(() => wrap.classList.remove('show'), 4200);
}

document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  document.querySelectorAll('.reveal-el, .product-card').forEach(el => revealObserver.observe(el));
  setTimeout(() => showFomo(fomoItems[0]), 9000);
  setInterval(() => { fomoIdx = (fomoIdx + 1) % fomoItems.length; showFomo(fomoItems[fomoIdx]); }, 20000);
});
